import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const hubUserService = {};

// List HubUser
hubUserService.listHubUser = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/hub-users`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};
// Create HubUser
hubUserService.createHubUser = data => {
  return fetchV2({
    url: `${env.API_MSP}/hub-users`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Detail HubUser
hubUserService.detailHubUser = ({
  hubUserId,
  params = { expand: undefined, fields: undefined },
}) => {
  return fetchV2({
    url: `${env.API_MSP}/hub-users/${hubUserId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || undefined,
      fields: params.fields || undefined,
    },
  });
};

// Update HubUser
hubUserService.updateHubUser = ({ hubUserId = undefined, data = {} }) => {
  return fetchV2({
    url: `${env.API_MSP}/hub-users/${hubUserId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Delete HubDelivery
hubUserService.deleteHubUser = (hubUserId = undefined) => {
  return fetchV2({
    url: `${env.API_MSP}/hub-users/${hubUserId}`,
    method: "delete",
  });
};

export default hubUserService;
